import type { MarketEditorialCreateTransport } from '../tx-engine/relay/market-editorial.js';

export const marketEditorialCreateTransport: MarketEditorialCreateTransport = async (request) => {
  const init: RequestInit = {
    method: request.method,
    headers: request.headers,
    body: request.body,
    credentials: 'include',
  };
  if (request.signal !== undefined) init.signal = request.signal;
  return fetch(request.path, init);
};
